console.log("Style guide JS loaded");

document.addEventListener("DOMContentLoaded", () => {
  
  // Step 1: Get the style number from the page
  function getStyleNumber() {
    // Use textContent, not innerText: the "Style #" lives inside a closed
    // <details> product-description accordion, and innerText omits text that
    // isn't currently rendered. textContent includes collapsed/hidden text.
    const pageText = document.body.textContent;
    // Accept both "Style #..." and "Style Number #..." labels — product copy
    // isn't consistent about the wording.
    const match = pageText.match(/Style\s*(?:Number)?\s*#\s*([A-Za-z0-9-]+)/i);
    
    if (match && match[1]) {
      const styleNumber = match[1].trim();
      console.log("✓ Style Number found:", styleNumber);
      return styleNumber;
    }
    
    console.log("✗ Style number not found on page");
    return null;
  }

  const styleNumber = getStyleNumber();
  
  // Only proceed if we found a style number
  if (!styleNumber) {
    console.log("No style number - size guide won't be shown");
    return;
  }

  // Step 2: Fetch and parse the TSV
  // Use the Liquid-generated asset URL (set in theme.liquid) so this keeps
  // working when the theme is duplicated/republished and its CDN id changes.
  // Fall back to the old hardcoded path only if the global is missing.
  const sizeDataUrl =
    window.MODAFLEUR_SIZE_DATA_URL ||
    "/cdn/shop/t/6/assets/modafleur_style_data.csv";

  fetch(sizeDataUrl)
    .then(r => {
      console.log("✓ TSV fetch response received");
      return r.text();
    })
    .then(tsv => {
      console.log("RAW TSV (first 300 chars):", tsv.slice(0, 300));

      // Parse TSV into structured data
      const rows = tsv.trim().split(/\r?\n/).map(r => r.split(","));
      console.log("Total rows:", rows.length);
      
      const headers = rows.shift();
      console.log("Headers:", headers);

      const data = rows.map(row => {
        const obj = {};
        headers.forEach((h, i) => {
          const val = row[i]?.trim();
          if (val) obj[h] = val;
        });
        return obj;
      });

      console.log("✓ Parsed", data.length, "size guide entries");

      // Step 3: Check if current style has size data
      const matchingEntries = data.filter(entry => entry.style === styleNumber);
      
      if (matchingEntries.length > 0) {
        console.log("✓ Found", matchingEntries.length, "size entries for", styleNumber);
        console.log("Matching data:", matchingEntries);
        
        // Step 4: Show the size guide button
        showSizeGuideButton(matchingEntries);
      } else {
        console.log("✗ No size data found for style:", styleNumber);
      }
    })
    .catch(err => console.error("✗ Failed to load TSV:", err));

  // Step 4: Create and show the size guide button
  function showSizeGuideButton(sizeData) {
    // Find where to insert the button (after size selector)
    // Try multiple selectors to find the size options area
    let insertTarget = document.querySelector('.product-form__input--size');
    
    if (!insertTarget) {
      // Try finding by name attribute
      const sizeInput = document.querySelector('[name="Size"]');
      insertTarget = sizeInput?.closest('.product-form__input') || sizeInput?.parentElement;
    }
    
    if (!insertTarget) {
      // Try finding variant selector container
      insertTarget = document.querySelector('variant-selects, variant-radios, .product-form__input');
    }
    
    if (!insertTarget) {
      // Last resort: find the add to cart button and insert before it
      const addToCartButton = document.querySelector('[name="add"]');
      insertTarget = addToCartButton?.parentElement;
    }

    if (!insertTarget) {
      console.log("✗ Could not find where to insert size guide button");
      console.log("Trying to inspect page structure...");
      // Log what we can find to help debug
      console.log("Forms on page:", document.querySelectorAll('form'));
      console.log("Product form:", document.querySelector('product-form'));
      return;
    }
    
    console.log("✓ Found insertion target:", insertTarget);

    // Create the button
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'size-guide-button';
    button.innerHTML = 'Size Guide';
    button.style.cssText = `
      display: inline-block;
      margin: 16px 0 8px 0;
      padding: 0;
      background: transparent;
      border: none;
      cursor: pointer;
      font-size: 15px;
      text-decoration: underline;
      transition: opacity 0.2s ease;
      font-family: inherit;
      color: #c7b32e;
      letter-spacing: 0.3px;
    `;

    
    button.addEventListener('mouseenter', () => {
      button.style.opacity = '0.7';
    });
    
    button.addEventListener('mouseleave', () => {
      button.style.opacity = '1';
    });

    button.addEventListener('click', () => {
      console.log("Size guide button clicked!");
      openSizeGuideModal(sizeData);
    });

    // Create a wrapper div for better control
    const wrapper = document.createElement('div');
    wrapper.className = 'size-guide-wrapper';
    wrapper.style.cssText = 'margin: 16px 0;';
    wrapper.appendChild(button);

    // Insert after the target element
    insertTarget.insertAdjacentElement('afterend', wrapper);
    console.log("✓ Size guide button added to page");
  }

  // Step 5: Create and open the modal
  function openSizeGuideModal(sizeData) {
    console.log("Opening modal with data:", sizeData);
    
    // Check if modal already exists, if so just show it
    let modal = document.getElementById('size-guide-modal');
    if (modal) {
      modal.style.display = 'flex';
      return;
    }
    
    // Create modal structure
    modal = document.createElement('div');
    modal.id = 'size-guide-modal';
    modal.className = 'size-guide-modal';
    
    const modalContent = document.createElement('div');
    modalContent.className = 'size-guide-modal-content';
    
    // Header
    const header = document.createElement('div');
    header.className = 'size-guide-header';
    header.innerHTML = `
      <h2>Size Guide</h2>
      <button class="size-guide-close" aria-label="Close">&times;</button>
    `;
    
    // Add subtitle with units
    const subtitle = document.createElement('div');
    subtitle.className = 'size-guide-subtitle';
    subtitle.textContent = 'All measurements are in inches';
    subtitle.style.cssText = `
      padding: 0 35px 20px 35px;
      font-size: 12px;
      color: #888;
      border-bottom: 1px solid #e0e0e0;
    `;
    
    // Build the size table
    const table = buildSizeTable(sizeData);
    
    // Assemble modal
    modalContent.appendChild(header);
    modalContent.appendChild(subtitle);
    modalContent.appendChild(table);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);
    
    // Add event listeners
    const closeBtn = modal.querySelector('.size-guide-close');
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
    
    // Close on backdrop click
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });
    
    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        modal.style.display = 'none';
      }
    });
    
    console.log("✓ Modal created and opened");
  }
  
  // Build the size table from data
  function buildSizeTable(sizeData) {
    const container = document.createElement('div');
    container.className = 'size-guide-table-container';
    
    // Get all keys from the first data row to detect available columns
    const firstRow = sizeData[0];
    const allColumns = Object.keys(firstRow);
    
    // Filter out style and variant, keep measurement columns
    const measurementColumns = allColumns.filter(col => 
      col !== 'style' && col !== 'variant'
    );
    
    // Further filter to only show columns that have actual data
    const activeColumns = measurementColumns.filter(col => 
      sizeData.some(row => row[col] && row[col].trim() !== '')
    );
    
    console.log("Available columns:", allColumns);
    console.log("Active measurement columns:", activeColumns);
    
    // Create table
    const table = document.createElement('table');
    table.className = 'size-guide-table';
    
    // Table header
    const thead = document.createElement('thead');
    const headerRow = document.createElement('tr');
    
    // Size column
    const sizeHeader = document.createElement('th');
    sizeHeader.textContent = 'Size';
    headerRow.appendChild(sizeHeader);
    
    // Measurement columns
    activeColumns.forEach(col => {
      const th = document.createElement('th');
      th.textContent = col.charAt(0).toUpperCase() + col.slice(1); // Capitalize
      headerRow.appendChild(th);
    });
    
    thead.appendChild(headerRow);
    table.appendChild(thead);
    
    // Table body
    const tbody = document.createElement('tbody');
    
    sizeData.forEach(row => {
      const tr = document.createElement('tr');
      
      // Size cell
      const sizeCell = document.createElement('td');
      sizeCell.className = 'size-cell';
      sizeCell.textContent = row.variant || '-';
      tr.appendChild(sizeCell);
      
      // Measurement cells
      activeColumns.forEach(col => {
        const td = document.createElement('td');
        td.textContent = row[col] || '-';
        tr.appendChild(td);
      });
      
      tbody.appendChild(tr);
    });
    
    table.appendChild(tbody);
    
    // Add notes if any exist
    const notesExist = sizeData.some(row => row.notes && row.notes.trim() !== '');
    if (notesExist) {
      const notesDiv = document.createElement('div');
      notesDiv.className = 'size-guide-notes';
      notesDiv.innerHTML = '<strong>Notes:</strong><br>';
      
      sizeData.forEach(row => {
        if (row.notes && row.notes.trim() !== '') {
          const note = document.createElement('p');
          note.textContent = `${row.variant}: ${row.notes}`;
          notesDiv.appendChild(note);
        }
      });
      
      container.appendChild(table);
      container.appendChild(notesDiv);
    } else {
      container.appendChild(table);
    }
    
    return container;
  }

});